import {KorterConverter} from "./KorterConverter";
import {
    Proposal,
    ProposalResource,
    Source,
    SOURCE_GEORGIA_BATUMI_KORTER,
    SOURCE_RELAPKA,
} from "../types/Proposal";
import { PartialRecord } from "../types/GeneralTypes";
import { RelapkaConverter } from "./RelapkaConverter";



export const ingestorConverters:PartialRecord<Source, PartialRecord<keyof Proposal, (data:unknown) => unknown>> = {
    [SOURCE_GEORGIA_BATUMI_KORTER]: KorterConverter
}
export const resourceConverters:PartialRecord<Source, PartialRecord<keyof ProposalResource, (data:unknown) => unknown>> = {
    [SOURCE_RELAPKA]: RelapkaConverter
}

export function adaptData(converter:string, field: keyof Proposal, data:unknown) {
    //@ts-ignore
    if(ingestorConverters[converter]) {
        //@ts-ignore
        if(ingestorConverters[converter][field]) {
            //@ts-ignore
            return ingestorConverters[converter][field](data);
        }
    }
    return data;
}
export function adaptImageData(converter:string, field: keyof ProposalResource, data:unknown) {
    //@ts-ignore
    if(resourceConverters[converter]) {
        //@ts-ignore
        if(resourceConverters[converter][field]) {
            //@ts-ignore
            return resourceConverters[converter][field](data);
        }
    }
    return data;
}